import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import IconSAT from '../../assets/images/icon-sat.svg'
import { useNavigate, useSearchParams } from "react-router-dom";
import liff from '@line/liff';
import { onLoginLineLiff } from "../../utils/default";
import { useLineDetail, useWebBackOfficeLineLoginSuccess } from "../../contexts";

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    background: linear-gradient(153.06deg, rgba(246, 210, 133, 0.3) -0.31%, rgba(187, 240, 243, 0.3) 99.69%);

    .icon {
        width: 100px;
    }
`;

function NotFoundPage() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { setWebBackOfficeLineLoginSuccess } = useWebBackOfficeLineLoginSuccess();
    const { setLineDetail } = useLineDetail();
    const searchParamsRef = useRef({
        evaluation_form_id: null,
        mode: "",
    })

    useEffect(() => {
        onInit();
    }, [])

    async function onInit() {
        searchParamsRef.current.evaluation_form_id = searchParams.get("evaluation_form_id");
        searchParamsRef.current.mode = searchParams.get("mode");
        let liffState = searchParams.get("liff.state");
        const state = localStorage.getItem("state");
        const evaluation_form_id = searchParamsRef.current.evaluation_form_id || localStorage.getItem("evaluation_form_id");
        if (evaluation_form_id) {
            await onCheckLineLiffEvaluator(evaluation_form_id, searchParamsRef.current.mode)
            return;
        } else if (liffState) {
            const firstChar = liffState.substring(0, 1)
            if (firstChar === "/" || firstChar === "?") {
                liffState = liffState.substring(liffState.length, 1);
            }
            let jsonQuery = queryStringToJSON(liffState);
            if (jsonQuery?.evaluation_form_id) {
                await onCheckLineLiffEvaluator(jsonQuery.evaluation_form_id, jsonQuery.mode)
                return;
            } else {
                if (liffState.includes("?")) {
                    const splitLiff = liffState.split("?")
                    if (splitLiff.length > 1) {
                        const rawLiff = splitLiff[1];
                        jsonQuery = queryStringToJSON(rawLiff);
                        if (jsonQuery?.evaluation_form_id) {
                            await onCheckLineLiffEvaluator(jsonQuery.evaluation_form_id, jsonQuery.mode)
                            return;
                        }
                    }
                }
            }
        } else if (state === "line_login") {
            const response = await onLoginLineLiff();
            if (response) {
                setWebBackOfficeLineLoginSuccess(true);
                setLineDetail(response);
                localStorage.removeItem("state")
                navigate(`/login?state=${state}`);
                return;
            } else {
                setWebBackOfficeLineLoginSuccess(false);
                setLineDetail(null);
            }
        }

        const redirectAfterLogin = localStorage.getItem("react_app_redirect_after_login");
        if (redirectAfterLogin) {
            const response = await onLoginLineLiff();
            if (response) {
                localStorage.removeItem("react_app_redirect_after_login");
                window.location.href = redirectAfterLogin;
            }
        }
    }

    function queryStringToJSON(queryString) {
        // Split the query string by '&' to get individual key-value pairs
        const pairs = queryString.split('&');

        // Reduce the pairs into an object
        const result = pairs.reduce((acc, pair) => {
            // Split each pair by '=' to separate the key and value
            const [key, value] = pair.split('=');

            // If the value is numeric, convert it to a number
            const parsedValue = isNaN(value) ? value : Number(value);

            // Assign the key and parsed value to the accumulator object
            acc[key] = parsedValue;
            return acc;
        }, {});

        return result;
    }
    async function onCheckLineLiffEvaluator(evaluation_form_id, mode) {
        localStorage.setItem("evaluation_form_id", evaluation_form_id);
        const lineLiffId = process.env.REACT_APP_LINE_LIFF_ID || "";
        if (lineLiffId) {
            const profile = await onInitLineLiff(lineLiffId);
            if (profile) {
                localStorage.removeItem("evaluation_form_id");
                const line_user_id = profile.userId || "";
                let url = `/evaluator/evaluation_form?evaluation_form_id=${evaluation_form_id}&line_user_id=${line_user_id}`;
                if (mode) {
                    url = url + `&mode=${mode}`;
                }
                url = url + `&cache=${(new Date()).getTime()}`;
                navigate(url);
            }
        }
    }
    async function onInitLineLiff(liffId) {
        let profile = null;
        try {
            await liff.init({
                liffId: `${liffId}`,
                withLoginOnExternalBrowser: true,
            }).catch(err => { throw err });
            if (liff.isLoggedIn()) {
                try {
                    profile = await liff.getProfile();
                } catch (err) {
                    console.log("onInitLineLiff.getProfile", err);
                    profile = null;
                }
                if (!profile) {
                    liff.login({
                        redirectUri: window.location.href,
                    });
                    return null;
                }
            } else {
                liff.login({
                    redirectUri: window.location.href,
                });
            }
        } catch (err) {
            console.log("onInitLineLiff", err)
        }
        return profile;
    }

    return (
        <Container className="content-center">
            <img alt="img" className="icon" src={IconSAT} />
        </Container>
    )
}

export default NotFoundPage;